/*
 * @Author: “zhangjiahao04”
 * @Date: 2023-08-23 15:50:14
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-10-26 16:07:36
 * @FilePath: \pico-ow2c-fe\src\pages\outer\about\index.tsx
 * @Description: 关于我们——动效 组件
 * @url:www.picoxr.com/cn/about
 */
import React, { useState, useEffect, useRef } from "react";
import { splitLine } from "@/common/splitLine";
import "./index.scss";
import { useDevice } from "@/hooks";
interface ImageGalleryProps {
  imageUrl: string; // 图片地址
  title: string; // 标题
  desc: string; // 描述
  minScaleWidth?: number; // 最小缩放宽度
  scrollTop?: number; // 滚动条距上高度
}

const ImageGallery: React.FC<ImageGalleryProps> = ({
  imageUrl,
  title,
  desc,
  minScaleWidth,
  scrollTop,
}) => {
  minScaleWidth = 1020;
  const device = useDevice();
  if (device === "pc") {
    minScaleWidth = 1020;
  } else if (device === "paid") {
    minScaleWidth = 640;
  } else if (device === "mobile") {
    minScaleWidth = 340;
  }

  const imageContainerRef = useRef<HTMLDivElement>() // 滚动元素最外层容器
  const imageRef = useRef<HTMLImageElement>() // 图片元素
  const [scaleIndex, setScaleIndex] = useState<number>(1) // 缩放比例
  const [allowScale, setAllowScale] = useState<boolean>(false) // 是否允许缩放
  const [beforeScrollTop, setBeforeScrollTop] = useState<number>(0) // 历史滚动位置
  const [scaleHeightGap, setScaleHeightGap] = useState<number>(0) // 从最小缩放开始放大时，图片与外层滚动容器的间距

  useEffect(() => {
    const { height: imageContainerHeight, bottom: imageContainerBottom } = imageContainerRef.current.getBoundingClientRect() // 滚动元素最外层容器的相对位置信息
    const { width: imageWidth, height: imageHeight, bottom: imageBottom } = imageRef.current.getBoundingClientRect() // 图片元素相对位置信息
    const scaleOffset = (window.innerHeight -imageHeight) / 2 //缩放偏移量
    const imageContainerOffsetTop = imageContainerRef.current.offsetTop // 滚动元素最外层容器距离顶部的距离
    const scrollStartPointHeight = imageContainerOffsetTop + scaleOffset // 滚动元素缩放过程中距离顶部的距离
    const scrollDirection = scrollTop >= beforeScrollTop // 根据历史滚动位置和现在滚动位置计算当前滚动方向（上滑还是下滑）
    const isAllowScale = imageWidth >= minScaleWidth // 允许缩放的最小宽度
    const isAllowAmplify = imageContainerBottom >= 0 // 上滑动作中，是否允许开始放大动画
    const amplifyFullEnd = imageContainerHeight - imageBottom === scaleHeightGap // 放大过程中，是否允许继续放大
    // 下滑动画
    if (isAllowScale && scrollDirection && scrollTop >= scrollStartPointHeight && scrollTop <= imageContainerOffsetTop + imageContainerHeight) {
      // 缩小到最终大小需要的滚动距离
      const scaleNeedHeight = imageContainerHeight
      // 最大缩放比例
      const maxScale = minScaleWidth / window.innerWidth
      // 开始缩放起点
      const startScale = imageRef.current.offsetTop + imageContainerRef.current.offsetTop
      // 当前缩放比
      const curScale = scaleIndex - (maxScale / scaleNeedHeight) * (scrollTop - startScale)
      // 设置缩放比
      setScaleIndex(curScale)
    }
    // 上滑动画
    if (isAllowAmplify && !scrollDirection && scrollTop >= scrollStartPointHeight && scrollTop <= imageContainerOffsetTop + imageContainerHeight && amplifyFullEnd) {
      // 放大到最终大小需要的滚动距离
      const scaleNeedHeight = imageContainerHeight
      // 开始放大起点
      const startScale = imageRef.current.offsetTop + imageContainerRef.current.offsetTop
      // 当前缩放比
      const curScale = scaleIndex + ((1 - scaleIndex) / scaleNeedHeight) * (scrollTop - startScale)
      // 设置缩放比
      setScaleIndex(curScale)
    }
    setScaleHeightGap(imageContainerHeight - imageBottom)
    setBeforeScrollTop(scrollTop)
    setAllowScale(isAllowScale)
  }, [scrollTop])

  return (
    <div className="image-container" ref={imageContainerRef}>
      <div className="image-wrapper">
        <img
          ref={imageRef}
          className="image"
          src={imageUrl}
          alt=""
          style={{
            borderRadius: `${scaleIndex < 0.99 ? 20 : 0}px`,
            transform: `scale(${scaleIndex})`
          }}
        />
        <div className="overlay" style={{
          borderRadius: `${scaleIndex < 0.99 ? 20 : 0}px`,
          opacity: `${!allowScale ? 1 : 0}`,
          transform: `scale(${scaleIndex})`
        }} />
        <div className="overlay-content" style={{
            opacity: `${!allowScale ? 1 : 0}`,
          }}>
          <div className="banner-content" style={{
            opacity: `${!allowScale ? 1 : 0}`,
          }}>
            <h1 className="banner-title">{title}</h1>
            <div className="banner-desc">{splitLine(desc)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;
